import { mapGetters } from 'vuex';
import mvtChart from '@/common/components/mvtchart/mvt-chart.vue';

export default {
    name: 'mvtLocalHighlightTempDetail',
    props: {
        monthlyAverage: {
            type: Object,
            default: null,
        },
        hideToggle: {
            type: Boolean,
            default: false,
        },
        city: {
            type: String,
            default: null,
        },
    },
    components: {
        mvtChart,
    },
    methods: {
        toggleMonthlyAvg() {
            this.$emit('toggle');
        },
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        getChartData() {
            if (!this.monthlyAverage) return null;

            var colors = ['#317CB8', '#B51851'];
            var colorsBg = ['rgb(230, 251, 254)', 'rgb(255, 243, 239)'];
            let datasets = [
                {
                    label: 'Low Temp',
                    data: this.monthlyAverage.low,
                    fill: true,
                    borderColor: colors[0],
                    backgroundColor: colorsBg[0],
                    borderWidth: 2,
                },
            ];
            datasets.push({
                label: 'High Temp',
                data: this.monthlyAverage.high,
                fill: true,
                borderColor: colors[1],
                backgroundColor: colorsBg[1],
                borderWidth: 2,
            });
            return {
                type: 'line',
                data: {
                    labels: this.monthlyAverage.months,
                    datasets: datasets,
                },
                options: {
                    legend: {
                        display: true,
                        position: 'bottom',
                        onClick: (e) => e.stopPropagation(),
                    },
                    scales: {
                        yAxes: [
                            {
                                display: true,
                                ticks: {
                                    precision: 0,
                                    userCallback: function (value) {
                                        return value + '°F';
                                    },
                                },
                            },
                        ],
                        xAxes: [
                            {
                                display: true,
                                gridLines: {
                                    color: 'rgba(0, 0, 0, 0)',
                                },
                            },
                        ],
                    },
                    tooltips: {
                        enabled: true,
                        titleAlign: 'center',
                        callbacks: {
                            label: (tooltipItems, data) => {
                                let temp = data.datasets && data.datasets[tooltipItems.datasetIndex] ? data.datasets[tooltipItems.datasetIndex].label + ' ' : '';
                                temp = temp.split(' ')[0];
                                return `${temp} (${tooltipItems.value + '°F'})`;
                            },
                        },
                    },
                    responsive: true,
                    maintainAspectRatio: false,
                },
            };
        },
        cityName() {
            return this.city || this.glb.geo.city;
        },
    },
};
